import { useState, useEffect, useCallback } from 'react'

import cx from 'classnames'

import { ButtonProps, Button } from '@/components/buttons/Button'
import { useClaimBonus } from '@/features/common/useClaimBonus'

import { StoreRewardItem } from '../../../../../../common/src/models/bonus'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './claimButton.module.scss'

export const ClaimButton: React.FC<Omit<ButtonProps, 'onClick'> & { item: StoreRewardItem }> = ({
  item,
  type,
  ...props
}) => {
  const claimBonus = useClaimBonus()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => {
        setLoading(false)
      }, 2000)
      return () => clearTimeout(timeout)
    }
  }, [loading])

  const onClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      e.stopPropagation()
      setLoading(true)
      const result = await claimBonus(item)
      if (!result) {
        // TODO: display proper error msg if claimBonus fails
        console.error('Claim bonus: failed')
      }

      setLoading(false)
    },
    [item, claimBonus],
  )
  return (
    <Button
      {...props}
      type={type}
      onClick={onClick}
      data-type="claim"
      additionalClasses={cx(styles.claimButton, styles.gradientBorder)}
      loading={loading}
    >
      <StoreTypography
        tag="span"
        style="plain"
        textSize="body"
        overrideFont="supercellTextMedium"
        className={styles.btnText}
      >
        Claim
      </StoreTypography>
    </Button>
  )
}
